import Model from "@/models/Model"

export default class WhOrdererPriority extends Model {
    resource() {
        return "wh_orderer_priority"
    }
}